import { motion } from "framer-motion";

export default function Author() {
  return (
    <section
      id="autora"
      data-testid="author-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream"
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        {/* Portrait card — limpo, sem texto sobreposto */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.45 }}
          className="md:col-span-5 relative md:sticky md:top-24"
        >
          <div className="relative aspect-[4/5] bg-blue overflow-hidden border border-line">
            {/* Pincelada laranja decorativa (canto superior direito) */}
            <svg
              viewBox="0 0 100 100"
              className="absolute top-0 right-0 w-2/3 h-2/3 opacity-70"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <path
                d="M 100 0 L 100 75 Q 60 55, 40 18 Q 70 8, 100 0 Z"
                fill="#E25A2C"
              />
            </svg>

            {/* Retrato */}
            <img
              src="/anabela_2026.jpg"
              alt="Anabela Reis"
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover z-10"
              data-testid="author-portrait"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.45, delay: 0.06 }}
          className="md:col-span-7"
        >
          <span className="section-num mb-6 inline-flex">06 · A autora</span>

          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-ink leading-[1.05] mb-10">
            A maioria dos livros
            <br />
            diz-te o que fazer.
            <br />
            <span className="font-serif-display text-orange normal-case lowercase">este vai fazer-te uma pergunta diferente.</span>
          </h2>

          <div className="space-y-5 text-lg text-ink-soft leading-relaxed">
            <p>
              Há mais de vinte anos que acompanho pessoas em momentos de viragem
              — e aprendi uma coisa que nenhuma formação me ensinou: o problema
              não é não saber. O problema é não se atrever a saber.
            </p>

            <p>
              Há uma pergunta que faço sempre — em consultório, em sala, em conversa:
            </p>

            <blockquote className="font-serif-display text-2xl md:text-3xl text-ink leading-snug border-l-2 border-orange pl-6 my-8">
              O que é que já sabes — e ainda não te dás permissão para dizer?
            </blockquote>

            <p>
              O que acontece a seguir nunca é silêncio vazio. É reconhecimento.
              É aquele momento em que alguém respira fundo e diz que sempre soube.
            </p>

            <p>
              E tu? Sempre soubeste. Este workbook existe para esse momento. Para
              quando estás pronta para parar de adiar a conversa mais importante
              da tua vida — a que tens contigo.
            </p>

            <p className="pt-6 border-t border-line text-ink-soft italic">
              Não o escrevi para te dizer o que fazer. Escrevi-o para que deixes
              de fingir que não sabes o que queres.
            </p>
            <p className="smallcaps">— Anabela Reis · Coach · Formadora · Autora</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
